import React, { FC } from 'react';
import { Container, useMediaQuery } from '@mui/material';
import useTitle from '../../utils/hooks/use-title';
import PageHeader from 'components/PageHeader/page-header.component';
import ImageType from 'utils/constants/imageType';
import PillType from 'utils/constants/pillType';

type IPage = {
  children: React.ReactNode;
  pageTitle: string;
  showHeader?: boolean;
  title?: string;
  pill?: PillType;
  imageOption?: ImageType;
  bgImage?: string;
};

const Page: FC<IPage> = ({
  children,
  pageTitle,
  title = 'Sorenson for Zoom',
  pill = PillType.Beta,
  imageOption = ImageType.Welcome,
  showHeader = true,
  bgImage,
}) => {
  useTitle(pageTitle);
  const matches = useMediaQuery((theme: any) => theme.breakpoints.up('md'));
  return (
    <Container
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '24px',
        height: '100%',
        maxWidth: bgImage ? '100%' : '400px',
        paddingTop: '36px',
        paddingBottom: '36px',
        background: `${
          matches ? `url(${bgImage})` : '#ffffff'
        }  no-repeat right`,
      }}
      maxWidth={false}
      className='container'
    >
      {showHeader ? (
        <PageHeader
          title={!!title}
          text={title}
          imageOption={imageOption}
          pill={pill}
        />
      ) : null}

      {children}
    </Container>
  );
};
export default Page;
